<template>
  <div class="func-union-wrap">
    <div class="func-union">
      <div
        class="func-item j-entry-coupon"
        v-if="isOpenCoupon"
        @click="handleGameCoupon"
      >
        <em class="ico iconfont icon-coupon"></em>
        <p class="name">{{ letter.voucherCoupon }}</p>
      </div>
      <div
        class="func-item j-entry-vip"
        v-if="isOpenVip || isOnlineRightsCenter"
        @click="handleVipJump"
      >
        <em class="ico iconfont icon-vip"></em>
        <p class="name">
          {{
            isOffLineTime && isOnlineRightsCenter
              ? letter.rightsCenterBtn
              : letter.voucherVip
          }}
        </p>
      </div>
      <div
        class="func-item j-entry-z-bit"
        @click="toWalletPage"
        v-if="showCoinEntry"
      >
        <em class="ico iconfont icon-zbin"></em>
        <p class="name">{{ letter.voucherYue }}</p>
      </div>
      <div
        class="func-item j-entry-more-coupon"
        v-if="isOpenMoreCoupon"
        @click="visibleWelfarePopupHandle(true)"
      >
        <em class="ico iconfont icon-more-coupon"></em>
        <p class="name">{{ letter.voucherMoreCoupon }}</p>
      </div>
    </div>
    <welfare-popup v-bind:visible.sync="visibleWelfarePopup"></welfare-popup>
    <coupon-list-popup
      v-if="isShowGameCouponPopup"
      popupType="game"
      :enableCouponList="gameCouponEnableList"
      :disableCouponList="gameCouponDisableList"
      :expireCouponList="gameCouponExpireList"
      :activeId="gameActiveCouponId"
      :showItemUseBtn="false"
      @closeCouponPopup="hideGameCouponPopup"
      :isPopup="true"
    ></coupon-list-popup>
  </div>
</template>

<script>
import coupon from '@mixins/officialWebStore/coupon';
import WelfarePopup from '@components/officialWebStore/WelfarePopup.vue';
import CouponListPopup from '@components/officialWebStore/coupon/CouponListPopup.vue';
import { mapGetters, mapState } from 'vuex';
import {
  locationType,
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV2';
import openActivity, { MAIN_BAR_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
import globalConfig from '@utiles/officialStore/globalConfig.js';
export default {
  mixins: [coupon],
  data() {
    return {
      visibleWelfarePopup: false
    };
  },
  created() {
    // 权益中心打开时带有showCoupon=1参数直接展示优惠券
    globalConfig.getHrefParam('showCoupon') === '1' && this.handleGameCoupon();
  },
  computed: {
    isHome() {
      return this.$route.name == 'home';
    },
    ...mapState({
      showCoinEntry: state => state.coins.showCoinEntry,
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    ...mapGetters(['getCoinsName', 'gameInfoConfig']),
    isOpenCoupon() {
      if (+this.gameId === 274 && this.lang === 'vi-VN') {
        return false;
      }
      return this.gameInfoConfig?.loginCenter?.isOpenCoupon || false;
    },
    isOpenVip() {
      if (+this.gameId === 274 && this.lang === 'vi-VN') {
        return false;
      }
      return this.gameInfoConfig?.loginCenter?.isOpenVip || false;
    },
    isOnlineRightsCenter() {
      return this.gameInfoConfig?.isOnlineRightsCenter || false;
    },
    isOffLineTime() {
      if (!this.gameInfoConfig?.offLineTime) {
        return false;
      }
      // 公告截止时间
      const announcementEndTime = new Date(this.gameInfoConfig?.offLineTime);
      // 获取当前时间（考虑时区）
      const currentTime = new Date();
      // 获取用户当前时区偏移量（分钟）
      const currentTimeZoneOffset = currentTime.getTimezoneOffset();
      // 调整当前时间为UTC时间，以便与公告截止时间比较
      const currentUTCTime = new Date(
        currentTime.getTime() - currentTimeZoneOffset * 60000
      );
      // 检查当前时间是否超过公告截止时间
      if (currentUTCTime > announcementEndTime) {
        return true;
      }
      return false;
    },
    isOpenMoreCoupon() {
      return this.gameInfoConfig?.loginCenter?.isOpenMoreCoupon || false;
    }
  },
  methods: {
    handleGameCoupon() {
      this.refreshGameCoupon();
      clickButton({
        btnName: 'btn_coupons',
        locationKey: locationType.mainBar
      });
    },
    handleVipJump() {
      clickButton({
        btnName: 'btn_vip',
        locationKey: locationType.mainBar
      });
      if (this.isOffLineTime && this.isOnlineRightsCenter) {
        openActivity(MAIN_BAR_ACTIVITY, this.gameInfoConfig?.rightsCenterLink, {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
        return;
      }
      this.$router.push({
        name: 'vipScore'
      });
    },
    toWalletPage() {
      clickButton({
        btnName: 'btn_coins',
        locationKey: locationType.mainBar
      });
      this.$router.push({
        name: 'wallet'
      });
    },
    visibleWelfarePopupHandle(bool) {
      clickButton({
        btnName: 'btn_events',
        locationKey: locationType.mainBar
      });
      this.visibleWelfarePopup = bool;
      showPopup(popupType.eventlistPopup);
    }
  },
  components: {
    WelfarePopup,
    CouponListPopup
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';

.func-union-wrap {
  position: relative;
  width: 710px;
  margin: 0 auto;
  border-radius: 10px;
  background-color: #fff;
  margin-top: 20px;
  box-shadow: 0px 10px 10px #e7e7e7;
  .func-union {
    position: relative;
    display: flex;
    justify-content: space-around;
    height: 139px;
    align-items: center;
    .func-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .ico {
        display: block;
        font-size: 30px;
      }
      .name {
        font-size: 22px;
        color: #333;
        margin-top: 25px;
      }
    }
  }
}

@media screen and (orientation: landscape) {
  .func-union-wrap {
    position: relative;
    width: 100%;
    margin-top: 30px;
    .func-union {
      flex-direction: column;
      padding: 0 20px;
      height: unset;
      .func-item {
        position: relative;
        justify-content: flex-start;
        flex-direction: row;
        border-bottom: 1px solid #dfdfdf;
        width: 100%;
        padding: 24px 0;

        &:last-child {
          border-bottom: none;
        }
        .name {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding-right: 23px;
          font-size: 16px;
          margin-top: 0;
          margin-left: 0;
          &:hover {
            color: $btnBg;
          }
        }
        .ico {
          font-size: 28px;
        }
      }
    }
  }
}
</style>
